import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import React from 'react';

export type ContentLinkProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
    className?: string;
};

function ContentLink({ className, ...props }: ContentLinkProps) {
    return <Button variant="link" className={cn('p-0', className)} {...props} />;
}

export default ContentLink;
